module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_08.eee7d427.jpg";